import MaterialReactTable from 'material-react-table'
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import AddIcon from '@mui/icons-material/Add';
import HomeIcon from '@mui/icons-material/Home';
import { useState, useEffect } from "react";
import {Button} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function ReactTablePopUpSubmitWrapper({
    title,
    columns,
    data,
    onClose,
    onRowSubmit,
    onCSVExport,
    onPDFExport,
    enableExportToolbar = false,
    enableTableSearch = true,
    isLoading = true,
    defaultPageSize = 5,
    onNewForm,
    addNewLabel = 'Add New',
    homeLink = '/Home',
    showQuickActions = true,
}) {

    const navigate = useNavigate();
    const [tableColumns, setTableColumns] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: defaultPageSize,
    });

    const handleHomeClick = () => {
        if (onClose) {
            onClose();
        }
        navigate(homeLink);
    };

    const handleNewClick = () => {
        if (onClose) {
            onClose();
        }
        if (onNewForm) {
            onNewForm();
        }
    };

    useEffect(() => {
        // console.log('Useeffect rendered');
        const tableColumns = columns.map(col => {

            let cellAlign = col.align || 'left';
            let columnProperties = {
                accessorKey: col.fieldName,
                header: col.headerName,
                size:col.size
            };

            if (col.headerName === 'ROW_ACTIONS') {
                columnProperties = {
                    ...columnProperties,
                    header: 'Action',
                    Header: <span style={col.headerStyle}>Action</span>,
                    Cell: ({renderedCellValue,row}) => {
                        // const customerStatus = row.original.customer_status;
                        return (
                            <span>
                                {(
                                    <CheckCircleIcon  onClick={(event) => onRowSubmit(renderedCellValue, event)} 
                                    sx={{
                                        cursor: 'pointer',
                                        color: 'white',
                                        fontSize: '24px',
                                        backgroundColor: 'primary.dark',
                                        margin: '3px',
                                        borderRadius: '15px',
                                        padding: '1px'
                                    }}
                                    />
                                    // <input type="checkbox"  onClick={(event) => onRowSubmit(renderedCellValue, event)}></input>
                                )}
                            </span>
                        );
                    }
                }
                
            } 
            else {

                if (col.headerStyle) {
                    columnProperties = {
                        ...columnProperties,
                        Header: <span style={col.headerStyle}>{col.headerName}</span>
                    };
                }

                columnProperties = {
                    ...columnProperties,
                    Cell: ({renderedCellValue}) => {

                        return (
                            <div style={{textAlign: cellAlign}}>
                                {col.dataStyle ? <span style={col.dataStyle}>{renderedCellValue}</span> : renderedCellValue}
                            </div>
                        
                        );
                    }
                };
            }

            return columnProperties;
        });

        setTableColumns(tableColumns);

    },[columns, onRowSubmit]);

    return (
        <div style={{paddingTop: "10px", paddingBottom: "10px"}}>
            <h1 style={{fontSize: '22px', color: 'darkblue', fontWeight: 'bold', display:'none'}}>{title}</h1>
            <MaterialReactTable
                columns={tableColumns}
                data={data}
                enablePinning
                enableStickyHeader
                enableColumnResizing
                // enableColumnOrdering
                // enableColumnDragging
                columnResizeMode="onEnd" 
                enableColumnActions={false}
                enableColumnFilters={enableTableSearch}
                enableGlobalFilter={enableTableSearch}
                enableFilters={enableTableSearch}
                enableToolbarInternalActions={enableTableSearch || enableExportToolbar}
                positionGlobalFilter="right"
                muiSearchTextFieldProps={{
                    placeholder: 'Search...',
                    size: 'small',
                    variant: 'outlined',
                    sx: { minWidth: '220px', backgroundColor: '#fff' },
                }}
                enablePagination={true}
                enableSorting={true}
                enableBottomToolbar={true}
                enableTopToolbar={enableTableSearch || enableExportToolbar}
                muiTableBodyRowProps={{hover: true}}
                enableDensityToggle={enableTableSearch || enableExportToolbar}
                state={{isLoading: isLoading, pagination}}
                onPaginationChange={setPagination}
                muiTablePaginationProps={{
                    rowsPerPageOptions: [5, 10, 15, 20, 25, 50, 100],
                    SelectProps: {
                        MenuProps: {
                            disablePortal: true,
                            sx: { zIndex: 3000 },
                        },
                    },
                }}
                muiTablePaperProps={{
                    elevation: 0,
                    sx: {
                      borderRadius: '0',
                      border: '1px solid #000000',
                    },
                  }}
                  muiTableBodyProps={{
                    sx: (theme) => ({
                      '& tr:nth-of-type(odd)': {
                        backgroundColor:'#bcbfc4',
                      },
                    }),
                  }}
                muiTableHeadCellProps={{
                    //simple styling with the `sx` prop, works just like a style prop in this example
                    sx: {
                      fontWeight: 'bold',
                      fontSize: '15px',
                      backgroundColor: '#6e8fec',
                      color:'white'
                    },
                  }}
                initialState={
                    {
                        density: "compact",
                        pagination: {pageIndex: 0, pageSize: defaultPageSize},
                        columnPinning: {  left:['id']}
                    }
                }
                renderTopToolbarCustomActions={
                    () => (
                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            <Button color="primary" onClick={onClose} variant="contained">CLOSE</Button>
                            {showQuickActions && onNewForm ? (
                                <Button
                                    color="primary"
                                    onClick={handleNewClick}
                                    variant="contained"
                                    title={addNewLabel}
                                    aria-label={addNewLabel}
                                    sx={{ minWidth: 40, px: 1 }}
                                >
                                    <AddIcon />
                                </Button>
                            ) : null}
                            {showQuickActions ? (
                                <Button
                                    color="primary"
                                    onClick={handleHomeClick}
                                    variant="contained"
                                    title="Home"
                                    aria-label="Home"
                                    sx={{ minWidth: 40, px: 1 }}
                                >
                                    <HomeIcon />
                                </Button>
                            ) : null}
                            {enableExportToolbar ? (
                                <>
                                    <Button color="primary" onClick={onCSVExport} startIcon={<FileDownloadRoundedIcon/>} variant="contained">Excel</Button>
                                    <Button color="primary" onClick={onPDFExport} startIcon={<FileDownloadRoundedIcon/>} variant="contained">PDF</Button>
                                </>
                            ) : null}
                        </span>
                    )
                }
            />
        </div>
    );
}

export default ReactTablePopUpSubmitWrapper;